import { type FC } from 'react';

type Props = {
  width?: number;
  height?: number;
};

export const LocationSignIcon: FC<Props> = ({ width = 36, height = 36 }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M36.5996 0H0.599609V36H36.5996V0Z" fill="white" fillOpacity="0.01" />
      <path
        d="M18.2344 9.61719V16.4442H33.2754L36.0954 13.0302L33.2754 9.61719H18.2344Z"
        fill="white"
        stroke="#2F353E"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M26.6836 16.4438V30.8338"
        stroke="#2F353E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.6836 5.13623V9.11423"
        stroke="#2F353E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12.833 30.834H29.657" stroke="#2F353E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M17.2497 15.0692H9.99372C9.96438 14.8802 9.94967 14.6893 9.94972 14.4982C9.94168 14.0112 10.0307 13.5275 10.2115 13.0752C10.3923 12.623 10.6613 12.2112 11.0028 11.864C11.3443 11.5168 11.7516 11.241 12.2008 11.0528C12.65 10.8645 13.1322 10.7676 13.6192 10.7676C14.1063 10.7676 14.5884 10.8645 15.0376 11.0528C15.4868 11.241 15.8941 11.5168 16.2356 11.864C16.5772 12.2112 16.8462 12.623 17.027 13.0752C17.2078 13.5275 17.2968 14.0112 17.2887 14.4982C17.2887 14.689 17.274 14.8796 17.2447 15.0682L17.2497 15.0692Z"
        stroke="#2F353E"
        strokeWidth="1.5"
      />
      <path
        d="M13.5616 30.8003H6.07656C5.88319 30.7948 5.69989 30.7129 5.56681 30.5725C5.43373 30.4321 5.36172 30.2447 5.36656 30.0513L3.98756 15.8183C3.98245 15.625 4.05423 15.4376 4.18715 15.2972C4.32008 15.1568 4.50328 15.0748 4.69656 15.0693H22.4266C22.6198 15.0748 22.803 15.1568 22.936 15.2972C23.0689 15.4376 23.1407 15.625 23.1356 15.8183L21.7566 30.0513C21.7614 30.2447 21.6894 30.4321 21.5563 30.5725C21.4232 30.7129 21.2399 30.7948 21.0466 30.8003H13.5616Z"
        fill="white"
        stroke="#2F353E"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3391 22.058C13.3833 21.9831 13.4463 21.9211 13.5218 21.878C13.5973 21.8349 13.6827 21.8123 13.7696 21.8123C13.8565 21.8123 13.9419 21.8349 14.0174 21.878C14.0929 21.9211 14.1559 21.9831 14.2001 22.058L15.9591 25.1L17.1881 22.974L16.9961 22.643L14.3591 18.079C14.297 17.9721 14.2079 17.8833 14.1008 17.8217C13.9937 17.76 13.8722 17.7275 13.7486 17.7275C13.625 17.7275 13.5035 17.76 13.3964 17.8217C13.2893 17.8833 13.2002 17.9721 13.1381 18.079L10.4971 22.648L10.3291 22.938L11.5811 25.104L13.3391 22.058Z"
        fill="#2F353E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.6546 27.2169L17.7736 23.9678L16.4176 26.3158C16.3735 26.4038 16.3037 26.4764 16.2176 26.5238C16.1035 26.5888 15.9685 26.6064 15.8417 26.5727C15.7149 26.539 15.6063 26.4568 15.5396 26.3438L13.7836 23.2979L12.0226 26.3428C11.9791 26.4181 11.9163 26.4803 11.8406 26.5229C11.7265 26.587 11.5918 26.6039 11.4654 26.5699C11.339 26.5359 11.231 26.4536 11.1646 26.3409L9.76456 23.9268L7.86456 27.2169C7.80172 27.3228 7.76855 27.4437 7.76855 27.5669C7.76855 27.69 7.80172 27.8109 7.86456 27.9169C7.92517 28.0252 8.01397 28.1151 8.12153 28.1771C8.2291 28.239 8.35143 28.2708 8.47556 28.2689H19.0436C19.1677 28.2703 19.29 28.2387 19.398 28.1773C19.5059 28.116 19.5956 28.0269 19.6578 27.9195C19.72 27.812 19.7524 27.6899 19.7519 27.5657C19.7513 27.4415 19.7177 27.3198 19.6546 27.2129V27.2169Z"
        fill="#2F353E"
      />
    </svg>
  );
};
